/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `m/s` - meter_per_second
 * * `km/h` - kilometer_per_hour
 * @export
 */
export const WindSpeedUnitsEnum = {
  M_S: "m/s",
  KM_H: "km/h",
} as const;
export type WindSpeedUnitsEnum = (typeof WindSpeedUnitsEnum)[keyof typeof WindSpeedUnitsEnum];

export function instanceOfWindSpeedUnitsEnum(value: any): boolean {
  for (const key in WindSpeedUnitsEnum) {
    if (Object.prototype.hasOwnProperty.call(WindSpeedUnitsEnum, key)) {
      if (WindSpeedUnitsEnum[key as keyof typeof WindSpeedUnitsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function WindSpeedUnitsEnumFromJSON(json: any): WindSpeedUnitsEnum {
  return WindSpeedUnitsEnumFromJSONTyped(json, false);
}

export function WindSpeedUnitsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WindSpeedUnitsEnum {
  return json as WindSpeedUnitsEnum;
}

export function WindSpeedUnitsEnumToJSON(value?: WindSpeedUnitsEnum | null): any {
  return value as any;
}

export function WindSpeedUnitsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): WindSpeedUnitsEnum {
  return value as WindSpeedUnitsEnum;
}
